// extracted by mini-css-extract-plugin
export default {"overlay-modal":"modal_overlay-modal__BUYU-","modal":"modal_modal__cnI7O","close":"modal_close__Enwnp"};